import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

export const formatDate = (
  dateStr?: string | null,
  formatStr: string = 'Do MMM YYYY',
  fallback: string = 'N/A',
) => {
  if (!dateStr || !moment(dateStr).isValid()) {
    return fallback;
  }
  return moment(dateStr).format(formatStr);
};

export const formatValue = (
  val?: string | number | null,
  fallback: string = 'N/A',
) => {
  if (val === undefined || val === null || val === '' || val === 'null') {
    return fallback;
  }
  return val;
};

interface DetailItemProps {
  label: string;
  value: React.ReactNode;
  labelWidth?: object | string | number;
  fallback?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

export const CommonDetailItem = ({
  label,
  value,
  labelWidth = { xs: '120px', sm: '140px', md: '160px' },
  fallback = 'N/A',
  xs = 12,
  sm,
  md,
  lg,
  xl,
}: DetailItemProps) => {
  let displayValue: React.ReactNode = value;

  if (value === undefined || value === null || value === '' || value === 'null') {
    displayValue = fallback;
  }

  const finalSm = sm ?? 6;
  const finalMd = md ?? finalSm;
  const finalLg = lg ?? (md !== undefined ? md : 4);

  return (
    <Grid item xs={xs} sm={finalSm} md={finalMd} lg={finalLg} xl={xl}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          py: 0.25,
        }}
      >
        <Typography
          variant='body2'
          fontWeight='600'
          color='text.primary'
          sx={{
            width: labelWidth,
            minWidth: labelWidth,
            flexShrink: 0,
            fontSize: { xs: '0.82rem', sm: '0.875rem' },
            lineHeight: 1.5,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant='body2'
          fontWeight='bold'
          color='text.secondary'
          sx={{ mx: { xs: 0.5, sm: 0.75 }, flexShrink: 0, lineHeight: 1.5 }}
        >
          :
        </Typography>
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            wordBreak: 'break-word',
            fontSize: { xs: '0.82rem', sm: '0.875rem' },
            lineHeight: 1.5,
          }}
        >
          {typeof displayValue === 'string' || typeof displayValue === 'number' ? (
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{
                wordBreak: 'break-word',
                fontSize: 'inherit',
                lineHeight: 1.5,
              }}
            >
              {displayValue}
            </Typography>
          ) : (
            displayValue
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default CommonDetailItem;
